import React from 'react'
import Image from 'next/image'
import { CustomerReviewRoot, ReviewCard, CustomerName, BorderWrapper, MobileImage, DesktopImage, Spacer} from './CustomerReview.styles'
import useTranslation from 'next-translate/useTranslation'
import { Rating } from 'features/Recipes/components/Reviews/Reviews'
import background from '../../../../../../../../public/assets/product/customerReviewBackground.webp'
import backgroundMobile from '../../../../../../../../public/assets/product/customerReviewBackground-m.webp'
import Trans from 'next-translate/Trans'
import { Text } from 'components/Text'
import { BorderWave } from 'components/BorderWave'

export const CustomerReview: React.FC = () => {
  const { t } = useTranslation('products')

  return (
    <CustomerReviewRoot>
      <DesktopImage>
        <Image src={background} alt={t('products:startr.customerReview.imageAlt')}  />
      </DesktopImage>
      <MobileImage>
        <Image src={backgroundMobile} alt={t('products:startr.customerReview.imageAlt')}  />
      </MobileImage>
      <ReviewCard>
        <Rating />
        <Text color="accent-black" size='bodyExtraLarge'><Trans components={{strong: <strong/>}} i18nKey={t('products:startr.customerReview.text')} /></Text>
        <CustomerName>{t('products:startr.customerReview.name')}</CustomerName>
      </ReviewCard>
      <BorderWrapper className="d-only">
        <BorderWave
          background="tertiary-200"
          svgHeight="120px"
          svgWidth="calc(153% + 1.3px)"
          path="M985.66,92.83C906.67,72,823.78,31,743.84,14.19c-82.26-17.34-168.06-16.33-250.45.39-57.84,11.73-114,31.07-172,41.86A600.21,600.21,0,0,1,0,27.35V120H1200V95.8C1132.19,118.92,1055.71,111.31,985.66,92.83Z"
        />
      </BorderWrapper>
      <BorderWrapper className="m-only">
        <BorderWave
          background="tertiary-200"
          svgHeight="60px"
          svgWidth="calc(153% + 1.3px)"
          path="M985.66,92.83C906.67,72,823.78,31,743.84,14.19c-82.26-17.34-168.06-16.33-250.45.39-57.84,11.73-114,31.07-172,41.86A600.21,600.21,0,0,1,0,27.35V120H1200V95.8C1132.19,118.92,1055.71,111.31,985.66,92.83Z"
        />
      </BorderWrapper>
      <Spacer className='m-only'/>
    </CustomerReviewRoot>
  )
}